import { type MouseEvent } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { LinkRoute } from '@/components/common/Link'
import { NavButtonLabel } from '@/components/common/NavButtonLabel'
import { type NavItemType } from '@/defs/nav'
import { cn } from '@/utils/commonUtil'
import { buildRoute } from '@/utils/routeUtil'

import styles from '../HeaderNav.module.scss'

type Props = {
  className?: string
  item: NavItemType
  onBlur?: () => void
  onClickLink?: (e: MouseEvent<HTMLElement>) => void
  showCaret?: boolean
}

export const HeaderNavButton = ({ className, item, onBlur, onClickLink, showCaret }: Props) => {
  const { hash, label, route, submenu } = item
  if (!label) return null

  return route ? (
    <LinkRoute
      analyticsEvent={{ action: 'nav_click', category: 'header' }}
      className={className}
      hash={hash}
      href={buildRoute(route)}
      onBlur={onBlur}
      onClick={onClickLink}
    >
      <NavButtonLabel item={item} styles={styles} />
    </LinkRoute>
  ) : (
    <ButtonRoot className={cn(className)} onBlur={onBlur} onClick={onClickLink}>
      <NavButtonLabel item={item} showCaret={showCaret && !!submenu} styles={styles} />
    </ButtonRoot>
  )
}
